<template>
    <v-container fluid> 
      <v-row>
        <v-col cols="8" class="mx-auto">     
          <v-alert
          text
          border="left"
          type="warning"      
          icon="mdi-alert-outline">
            Esta página no es accesible directamente
          </v-alert>   
        </v-col> 
      </v-row>
    </v-container>
</template>


<script>

export default {
    name: 'EmptyMain',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>